// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Timer__root--OY5wB {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--premium-solid-color);
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
}

    .Timer__root--OY5wB > span {
        width: 52px;
        height: 36px;
        font-variant-numeric: tabular-nums;
        border-radius: 6px;
        background-color: var(--premium-solid-color);
        color: var(--darkest-color);
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
        text-transform: uppercase;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        /* &::before {
            counter-reset: my-counter var(--num);
            content: counter(my-counter);
            animation: count59 5s ease-in-out;
        }

        &:first-child::before {
            animation: count29 5s ease-in-out;
        }

        &:nth-child(2)::before {
            animation: count23 5s ease-in-out;
        } */
    }

    .Timer__root--OY5wB.Timer__start--gGUtA > span::before {
        content: '';
        display: none;
    }

    @media screen and (min-width: 1024px) {
        .Timer__root--OY5wB > span {
            width: 60px;
            height: 44px;
            font-size: 16px;
        }
    }


@property --num {
    syntax: '<integer>';
    inherits: true;
    initial-value: 0;
}

@keyframes Timer__count29--RZhNd {
    to { --num: 29; }
}

@keyframes Timer__count23--oBehk {
    to { --num: 23; }
}

@keyframes Timer__count59--xYMLK {
    to { --num: 59; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Timer/Timer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AA4CrB;;IA1CI;QACI,WAAW;QACX,YAAY;QACZ,kCAAkC;QAClC,kBAAkB;QAClB,4CAA4C;QAC5C,2BAA2B;QAC3B,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,yBAAyB;QACzB,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;;QAEvB;;;;;;;;;;;;WAYG;IACP;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI;YACI,WAAW;YACX,YAAY;YACZ,eAAe;QACnB;IACJ;;;AAIJ;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,KAAK,SAAS,EAAE;AACpB;;AAEA;IACI,KAAK,SAAS,EAAE;AACpB;;AAEA;IACI,KAAK,SAAS,EAAE;AACpB","sourcesContent":[".root {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--premium-solid-color);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 20px;\n\n    > span {\n        width: 52px;\n        height: 36px;\n        font-variant-numeric: tabular-nums;\n        border-radius: 6px;\n        background-color: var(--premium-solid-color);\n        color: var(--darkest-color);\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 20px;\n        text-transform: uppercase;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n\n        /* &::before {\n            counter-reset: my-counter var(--num);\n            content: counter(my-counter);\n            animation: count59 5s ease-in-out;\n        }\n\n        &:first-child::before {\n            animation: count29 5s ease-in-out;\n        }\n\n        &:nth-child(2)::before {\n            animation: count23 5s ease-in-out;\n        } */\n    }\n\n    &.start > span::before {\n        content: '';\n        display: none;\n    }\n\n    @media (--large) {\n        > span {\n            width: 60px;\n            height: 44px;\n            font-size: 16px;\n        }\n    }\n}\n\n\n@property --num {\n    syntax: '<integer>';\n    inherits: true;\n    initial-value: 0;\n}\n\n@keyframes count29 {\n    to { --num: 29; }\n}\n\n@keyframes count23 {\n    to { --num: 23; }\n}\n\n@keyframes count59 {\n    to { --num: 59; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Timer__root--OY5wB`,
	"start": `Timer__start--gGUtA`,
	"count29": `Timer__count29--RZhNd`,
	"count23": `Timer__count23--oBehk`,
	"count59": `Timer__count59--xYMLK`
};
export default ___CSS_LOADER_EXPORT___;
